<template>
	<div>
		<div class="load-demographic mb-3 p-4">
			<div class="d-flex">
				<div class="cursor-pointer me-4">
					<img
						alt="create new"
						class="img-fluid"
						height="52"
						src="@/assets/images/set-question/list.svg"
						width="50"
					/>
				</div>
				<div class="" @click="loadAllDemographicQuestionStatus = true">
					<h4 class="sub-title cursor-pointer text-capitalize">
						Load Saved Demographic
					</h4>
					<p class="description m-0">
						Service description will go here to inform the user what it should
						mean
					</p>
				</div>
			</div>
		</div>
		<div>
			<Custom-question-body></Custom-question-body>
		</div>

		<transition name="fade">
			<div
				v-if="loadAllDemographicQuestionStatus"
				class="modal-layout position-fixed d-flex justify-content-center align-items-center"
			>
				<loadAllDemographicQuestion
					@hide-modal="loadAllDemographicQuestionStatus = false"
					@add-questions-event="addQuestions"
				/>
			</div>
		</transition>
		<div class="d-flex justify-content-end my-5">
			<div class="me-3 text-capitalize filter-button p-0">
				<label class="btn-content px-5" @click="finalQuestionList('skip')"
					>skip</label
				>
			</div>
			<div class="me-3 text-capitalize filter-button p-0">
				<label class="btn-content px-5" @click="finalQuestionList('next')"
					>next</label
				>
			</div>
		</div>
	</div>
</template>

<script>
import CustomQuestionBody from "./custom-question-body.vue";
import LoadAllDemographicQuestion from "./load-all-demographic-question";
import { mapGetters } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";

export default {
	name: "CustomQuestion",
	components: { CustomQuestionBody, LoadAllDemographicQuestion },
	inject: ["finalizeStatus"],
	data() {
		return {
			loadAllDemographicQuestionStatus: false,
		};
	},
	computed: {
		...mapGetters("surveyJourney", {
			demographicQuestionsOfCurrentSurvey:
				"demographicQuestionsOfCurrentSurvey",
		}),
	},
	methods: {
		addQuestions(selectedQuestions) {
			this.$store.dispatch(
				"surveyJourney/addDemographicQuestionFromSavesOnes",
				{ selectedQuestions }
			);
		},

		finalQuestionList(type) {
			let demographicQuestionsList = [];
			this.finalizeStatus();
			setTimeout(() => {
				let finalizeTab = document.querySelector("#finalize-tab");
				var targetTab = new bootstrap.Tab(finalizeTab);
				targetTab.show();
				finalizeTab?.addEventListener("shown.bs.tab", function(event) {
					event.relatedTarget.style.background = "#42C1A9";
					event.target.style.background = "#fff";
				});
			});

			if (type === "next") {
				demographicQuestionsList = this.demographicQuestionsOfCurrentSurvey.map(
					({ code }, index) => ({
						code,
						order: index + 5,
					})
				);
			}

			this.$store.dispatch(
				"surveyJourney/demographicQuestionsList",
				demographicQuestionsList
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.load-demographic {
	border: $border-white-1;
	border-radius: $radius-20;
}

.description {
	@extend %font-16_18-regular;
	letter-spacing: 0;
	color: $color-grey-40;
}

.sub-title {
	@extend %font-26_28-regular;
}
</style>
